import { AutogenModelWirecodesForUser, AutogenRowWirecodesForUser } from "./autogen/AutogenModelWirecodesForUser";

export class ModelWirecodesForUser extends AutogenModelWirecodesForUser<RowWirecodesForUser> {
    constructor() {
        super(RowWirecodesForUser);
    }
}

export class RowWirecodesForUser extends AutogenRowWirecodesForUser {
}